// import React from "react";

// function Counter({ quantity, onQuantityChange, textSize, textColor }) {
//   const handleIncrement = () => {
//     onQuantityChange(quantity + 1);
//   };

//   const handleDecrement = () => {
//     if (quantity > 1) {
//       onQuantityChange(quantity - 1);
//     }
//   };

//   return (
//     <div
//       className={`flex items-center border rounded-full w-max ${
//         textColor ? textColor : "text-[#A9A9A9]"
//       } ${textColor ? "px-3 border-[#A9A9A9]" : ""}`}
//     >
//       <button
//         className={`pl-2 ${
//           textSize ? textSize : "text-[.8rem] lg:text-[1.25rem]"
//         }  `}
//         onClick={handleDecrement}
//       >
//         -
//       </button>
//       <span
//         className={` ${
//           textSize ? "lg:text-[1.2rem] text-[1rem] mx-6" : "text-[.7rem] mx-3 "
//         }  `}
//       >
//         {quantity}
//       </span>
//       <button
//         className={`${
//           textSize ? textSize : "text-[.8rem] lg:text-[1.25rem]"
//         }  pr-2`}
//         onClick={handleIncrement}
//       >
//         +
//       </button>
//     </div>
//   );
// }

// export default Counter;

import React, { useEffect, useState } from "react";
import { AdminCashier } from "../../Protect/HiddenLink";

function Counter({
  quantity,
  onQuantityChange,
  textSize,
  textColor,
  deduction = true,
}) {
  const [inputValue, setInputValue] = useState(quantity);

  const handleIncrement = () => {
    const newQuantity = inputValue + 1;
    setInputValue(newQuantity);
    onQuantityChange(newQuantity);
  };

  const handleDecrement = () => {
    if (inputValue > 1) {
      const newQuantity = inputValue - 1;
      setInputValue(newQuantity);
      onQuantityChange(newQuantity);
    }
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    if (value === "") {
      setInputValue("");
      return;
    }

    const parsedValue = parseInt(value, 10);
    if (!isNaN(parsedValue) && parsedValue > 0) {
      setInputValue(parsedValue);
      onQuantityChange(parsedValue);
    }
  };

  const handleBlur = () => {
    if (inputValue === "" || isNaN(inputValue)) {
      setInputValue(quantity);
    }
  };
  useEffect(() => {
    setInputValue(quantity);
  }, [quantity]);
  return (
    <div
      className={`flex items-center border rounded-full w-max ${
        textColor ? textColor : "text-[#A9A9A9]"
      } ${textColor ? "px-2 border-[#A9A9A9]" : ""}`}
    >
      {!deduction ? (
        <AdminCashier>
          <button
            className={`pl-1.5 ${
              textSize ? textSize : "text-[.8rem] lg:text-[1.2rem]"
            }`}
            onClick={handleDecrement}
          >
            -
          </button>
        </AdminCashier>
      ) : (
        <button
          className={`pl-1.5 ${
            textSize ? textSize : "text-[.8rem] lg:text-[1.2rem]"
          }`}
          onClick={handleDecrement}
        >
          -
        </button>
      )}
      <input
        type="text"
        value={inputValue}
        onChange={handleInputChange}
        onBlur={handleBlur}
        className="w-8 text-center border-none outline-none bg-transparent text-[.8rem] lg:text-[.9rem] mx-1"
      />
      <button
        className={`pr-1.5 ${
          textSize ? textSize : "text-[.8rem] lg:text-[1.2rem]"
        }`}
        onClick={handleIncrement}
      >
        +
      </button>
    </div>
  );
}

export default Counter;
